import React, { useRef, useState } from 'react';
import './DeliveryBlockInfo.scss';
import './DeliveryBlockInfo-media.scss';
import { AnchorSection } from 'react-anchor-navigation';
import { connect, WithStore, MapStateToProps, MapDispatchToProps } from '../../redux/services/Imports';
import Button from '../Button/Button';
import { bodyAuto, bodyHidden } from '../../services/GlobalFunctions';
import ModalForm from '../ModalForm/ModalForm';
import ModalTableTariffs from '../ModalTableTariffs/ModalTableTariffs';
import {IDeliveryInfo, IDeliveryItem, ITariffTable} from './interfaces';
import { EnumUrlsPages } from '../../services/Enum';
import DescriptionBlock from '../DescriptionBlock/DescriptionBlock';
import CardCount from '../CardCount/CardCount';
import Content from '../Content/Content';
import { Props } from './interfaces';
import { CSSTransition } from 'react-transition-group';
import {getDeliveryBlockBgByColor, textPriceInRubles} from "../../services/content/functions";
import {content} from "../../services/content";
import {IWordpressServicesBlock} from "../../services/content/interfaces/IWordpressServicesBlock";

const DeliveryBlockInfo = ({ widthWindow, pageContent }: Props) => {
  const [showPopup, setShowPopup] = useState(false);
  const openModal = () => setShowPopup(true);
  const closedModal = () => {
    bodyAuto();
    setShowPopup(false);
  };

  const [showTariffs, setShowTariffs] = useState(false);
  const [titleModalTariffs, setTitleModalTariffs] = useState(content.deliveryBlockInfo.textTariffs);
  const [tariffs, setTariffs] = useState<ITariffTable>();
  const openTariffs = (tariffs: ITariffTable) => () => {
    bodyHidden();
    setShowTariffs(true);
    setTariffs(tariffs);
    setTitleModalTariffs(`${content.deliveryBlockInfo.textTariffs} - ${tariffs.title}`);
  };
  const closedTariffs = () => {
    bodyAuto();
    setShowTariffs(false);
  };

  const nodeRef = useRef(null);
  const isMobile = widthWindow <= 720;

  const ServicesBlock1 = (data: IWordpressServicesBlock) => {
    const cards: {grid: number, color?: string, list: string[]}[] = [];
    const items = data.items.map(({title}) => title);
    if (isMobile) {
      cards.push({
        grid: 3,
        color: '#4DC4FF',
        list: items
      });
    } else {
      cards.push({
        grid: 3,
        color: '#4DC4FF',
        list: items.slice(0, 5)
      });
      cards.push({
        grid: 4,
        list: items.slice(5, 9)
      });
      cards.push({
        grid: 3,
        list: items.slice(9, 15)
      })
    }

    let numberCard = 0;

    return (
      <div className="delivery-block-info__item">
        <div className="delivery-block-info__bg-dalli"></div>
        <AnchorSection id='courier'>
          <DeliveryTitle title={data.title} price={data.price}/>
        </AnchorSection>
        <Content
          width={widthWindow > 720 ? '' : '100%'}
          block={
            <>
              <div className="delivery-block-info__grid-2">
                <img
                  src={data.logo}
                  className="delivery-block-info__logo"
                  alt="delivery-logo"
                />
                <Button
                  text={content.deliveryBlockInfo.textButton}
                  type="border"
                  size={widthWindow > 720 ? 'M' : 'S'}
                  link={EnumUrlsPages.calculator}
                />
              </div>

              {cards.map(({ grid, list, color }, i) => (
                <div className={`delivery-block-info__grid-${grid}`} key={i}>
                  <div className="delivery-block-info__bg">
                    {color === '#4DC4FF' ? content.deliveryBlockInfo.svgBgDalli : getDeliveryBlockBgByColor(color)}
                  </div>

                  {list.map((text, idx) => {
                    numberCard++;
                    return <CardCount {...{ text, idx, color, numberCard }} key={idx} />;
                  })}
                </div>
              ))}

              {data.description ? <DescriptionBlock {...data.description} /> : null}
            </>
          }
        />
      </div>
    );
  }

  const ServicesBlock2 = (data: IWordpressServicesBlock) => {
    const cards: {grid: number, color?: string, list: string[]}[] = [];
    cards.push({
      grid: 3,
      color: 'rgb(25, 55, 255)',
      list: data.items.map(({title}) => title)
    })
    let numberCard = 0;

    return (
      <div className="delivery-block-info__item">
        <div className="delivery-block-info__bg-dalli"></div>
        <AnchorSection id='ru'>
          <DeliveryTitle title={data.title} price={data.price}/>
        </AnchorSection>
        <Content
          width={widthWindow > 720 ? '' : '100%'}
          block={
            <>
              <div className="delivery-block-info__grid-2">
                <img
                  src={data.logo}
                  className="delivery-block-info__logo"
                  alt="delivery-logo"
                />
                <Button
                  text={content.deliveryBlockInfo.textButton}
                  type="border"
                  size={widthWindow > 720 ? 'M' : 'S'}
                  link={EnumUrlsPages.calculator}
                />
              </div>

              {cards.map(({ grid, list, color }, i) => (
                <div className={`delivery-block-info__grid-${grid}`} key={i}>
                  <div className="delivery-block-info__bg">
                    {color === '#4DC4FF' ? content.deliveryBlockInfo.svgBgDalli : getDeliveryBlockBgByColor(color)}
                  </div>

                  {list.map((text, idx) => {
                    numberCard++;
                    return <CardCount {...{ text, idx, color, numberCard }} key={idx} />;
                  })}
                </div>
              ))}

              {data.description.title || data.description.text ? <DescriptionBlock {...data.description} /> : null}
            </>
          }
        />
      </div>
    );
  }

  return (
    <div className="delivery-block-info">
      {pageContent.services_block1 && <ServicesBlock1 {...pageContent.services_block1}/>}
      {pageContent.services_block2 && <ServicesBlock2 {...pageContent.services_block2}/>}

      <ModalForm
        hasCssTransition
        showForm={showPopup}
        id="zoom"
        title={content.deliveryBlockInfo.textModalTitle}
        buttonText={content.deliveryBlockInfo.textModalButton}
        image={require('../ModalForm/img/zoom.png')}
        closedModal={closedModal}
        eventMetrika="form_zoom"
        sendAmoCRM
      />

      <CSSTransition
        in={showTariffs}
        nodeRef={nodeRef}
        timeout={{appear: 200, enter: 0, exit: 200}}
        classNames="css-transition-modal"
        unmountOnExit
      >
        <ModalTableTariffs
          nodeRef={nodeRef}
          title={titleModalTariffs}
          closedModal={closedTariffs}
          tariffs={tariffs}
        />
      </CSSTransition>
    </div>
  );
};

export default WithStore()(connect(MapStateToProps, MapDispatchToProps)(DeliveryBlockInfo));

const Anchor = ({content, idHash}: { content: JSX.Element; idHash: string }) => {
  return <AnchorSection id={idHash}>{content}</AnchorSection>;
};

const DeliveryTitle = ({title, price}: { title: string; price: string }) => {
  return (
    <div className="delivery-block-info__grid-2 delivery-block-info__grid-2_media-column">
      <h2 className="delivery-block-info__title">{title}</h2>
      <h2 className="delivery-block-info__price">{price}</h2>
    </div>
  );
};
